<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                     <v-btn dark icon title="Back to Payroll Menu" @click="$router.push('/payroll')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="payroll" pageId="my-payslip" color="white"></help-link>
                    <v-menu left v-model="menu_status" offset-y > 
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark v-on="on">
                                <span class="ml-7   ">CY {{selectedFiscalYear}}</span>
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-for="(item,index) in fiscal_years" :key="index" :title="`Calendar Year ${item.fiscalYear}`" @click="setFiscalYear(item.fiscalYear)">
                                <v-list-tile-title small>CY {{item.fiscalYear}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-card>

            <!-- payslips -->
            <v-card class="elevation-1 mt-5"> 
                <v-toolbar flat height="45px">
                    <div class="wp-30 mb-10">
                        <v-text-field v-model="search" append-icon="search" label="Search date" single-line hide-details clearable></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                    <span class="font-weight-bold ">Click PDF icon to view payslip</span>
                </v-toolbar>
                <v-data-table
                    :headers="isMobile?headers_mobile:headers"
                    :items="cutoff_periods_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <template v-slot:items="props">
                        <tr 
                            @click="generatePayslipPDF(props.item, props.index)" 
                            :title="canViewPayslip(props.item) ? 'Click to preview payslip':'Payslip not available yet'" 
                            :class="canViewPayslip(props.item)?'clickable':''"                            
                        >
                            <td v-if="isMobile" :class="isCurrentPeriod(props.item)?'font-weight-bold':''">{{ getCutoffDescription(props.item) }}</td>
                            <td v-if="!isMobile" :class="isCurrentPeriod(props.item)?'font-weight-bold':''">{{props.item.cutOffPeriodDesc}}</td>
                            <td v-if="!isMobile" :class="isCurrentPeriod(props.item)?'font-weight-bold':''">{{ props.item.cutOffStart | moment("MMM DD, YYYY") }}</td>
                            <td v-if="!isMobile" :class="isCurrentPeriod(props.item)?'font-weight-bold':''">{{ props.item.cutOffEnd | moment("MMM DD, YYYY") }}</td>
                            <td v-if="!isMobile" :class="isCurrentPeriod(props.item)?'font-weight-bold':''">
                                <span :class="commonfn.getStatusColor(props.item.cutOffStatus)">{{commonfn.getStatusDescription(props.item.cutOffStatus)}}</span>
                            </td>
                            <td :class="isCurrentPeriod(props.item)?'font-weight-bold':''">
                                <span :class="commonfn.getStatusColor(props.item.payrollStatus)">{{commonfn.getStatusDescription(props.item.payrollStatus)}}</span>
                            </td>
                            <td :class="isCurrentPeriod(props.item)?'font-weight-bold':''">
                                <v-btn v-if="canViewPayslip(props.item)" icon :loading="loading_pdf[props.index].value" small>
                                    <v-icon>fas fa-file-pdf</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>

            <!-- annualization -->
            <v-card v-if="annualizationAdjustmentProcessed" class="elevation-1 mt-5"> 
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold">Annualization</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table
                    :headers="headers_annualization"
                    :items="[{fiscalYear:selectedFiscalYear, anualization: '', 2316:''}]"
                    :loading="loading"
                    hide-actions
                >
                    <template v-slot:items="props">
                        <tr>
                            <td>{{props.item.fiscalYear}}</td>
                            <td>
                                <v-btn @click="previewPdf" icon :loading="loading_annualization" small title="View Annualization Report in PDF">
                                    <v-icon>fas fa-file-pdf</v-icon>
                                </v-btn>
                            </td>
                            <td>
                                <v-btn @click="previewMy2316" icon :loading="loading_2316" small title="View BIR 2316 Report in PDF">
                                    <v-icon>fas fa-file-pdf</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>

            <br>
        </v-flex>
        <v-dialog v-model="dialogPreview" fullscreen hide-overlay transition="dialog-bottom-transition">
            <preview ref="refPdfPreviewComponet" :dialogPreview.sync="dialogPreview"></preview>
        </v-dialog>
    </v-layout> 
</template>

<script>

import payrollApi from '@/api/payroll'
import annualizationApi from '@/api/annualization'
import commonfn from '@/common/functions'   //for refactor
import awsS3Helper from '@/helpers/aws-s3'
import AWSS3DocumentType from '@/constants/aws-s3-document-types'
import rowsPerPageItems from '@/constants/rows-per-page'
import { getSort, getRowsPerPage, getCalendarYear, getSearchKeyword, updateCalendarYear, updateRowsPerPage, updateSort, updateSearchKeyword } from '@/helpers/user-prefs'
import { getCutoffCoverageDescription } from '@/helpers/cutoff-format'

export default {     
    name: 'MyPayslip',
    metaInfo: {
        title: 'My Payslip',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View, generate payroll' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'preview': () => import('@/components/FilePreview/Preview'),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)
        
        return {
            commonfn,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            selectedFiscalYear: getCalendarYear(routeName),
            search: getSearchKeyword(routeName),
            headers_mobile: [
                {text: 'Cutoff',align: 'left',value: 'cutOffStart', width: '50%', sortable:true},
                {text: 'Status',align: 'left',value: 'payrollStatus',  width: '40%', sortable:true},
                {text: 'Payslip',align: 'left',value: '',  width: '10', sortable:false},
            ],
            headers: [
                {text: 'Period',align: 'left',value: 'cutOffPeriodDesc', width: '10%', sortable:true},
                {text: 'Cutoff Start Date',align: 'left',value: 'cutOffStart', width: '10%', sortable:true},
                {text: 'Cutoff End Date',align: 'left',value: 'cutOffEnd', width: '10%', sortable:true},
                {text: 'CutOff Status',align: 'left',value: 'cutOffStatus',  width: '10%', sortable:true},
                {text: 'Payroll Status',align: 'left',value: 'payrollStatus',  width: '10%', sortable:true},
                {text: 'Payslip',align: 'left',value: '',  width: '10%', sortable:false},
            ],
            headers_annualization: [
                {text: 'Calendar Year',align: 'left',value: '', width: '33%', sortable:false},
                {text: 'Annualization Report',align: 'left',value: '', width: '33%', sortable:false},
                {text: 'BIR 2316',align: 'left',value: '', width: '33%', sortable:false}
            ],
            error: false,
            errorMessage: '',
            loading: false,
            loading_annualization: false,
            loading_2316: false,
            loading_pdf: [],
            dialogPreview: false,
            cutoff_periods: [],            
            menu_status: false,
            annualization: null
        }
    },
    methods: { 
        getCutoffDescription(data) {
            return getCutoffCoverageDescription(data.cutOffStart, data.cutOffEnd)
        },
        isCurrentPeriod(data){
            return data.cutOffPeriodDesc == 'Current'
        }, 
        canViewPayslip(data) {
            return commonfn.getStatusDescription(data.payrollStatus) == 'Approved' || commonfn.getStatusDescription(data.payrollStatus) == 'Credited'
        },
        async setFiscalYear(fiscalYear) {
            this.selectedFiscalYear = fiscalYear
            await this.getAnnualizationByUser()
            updateCalendarYear(this.$route.name, fiscalYear)
        },
        async previewMy2316() {
            try {
                this.loading_2316 = true 
                const response = await annualizationApi.getMy2316Url(this.fiscalPeriodId)
                if (response && response.status == 200) {
                    var file = {
                        name: response.data.fileName,
                        type: 'Pdf',
                        url: response.data.url,
                        downloadUrl: awsS3Helper.getEmployeeDocumentUrl(this.myUserId, response.data.fileName, AWSS3DocumentType.BIR2316)
                    }
                    this.$refs.refPdfPreviewComponet.setParams(file)
                    this.loading_2316 = false
                    this.dialogPreview = true
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async previewPdf() {
            try {
                this.loading_annualization = true 
                const response = await annualizationApi.getMyPDFUrl(this.fiscalPeriodId)
                if (response && response.status == 200) {
                    var file = {
                        name: response.data.fileName,
                        type: 'Pdf',
                        url: response.data.url,
                        downloadUrl: awsS3Helper.getEmployeeDocumentUrl(this.myUserId, response.data.fileName, AWSS3DocumentType.Annualization)
                    }
                    this.$refs.refPdfPreviewComponet.setParams(file)
                    this.loading_annualization = false
                    this.dialogPreview = true
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getAnnualizationByUser() {
            try {
                this.loading = true
                const response = await payrollApi.getMyAnnualization(this.selectedFiscalYear)
                if (response.status==200) {
                    this.annualization = response.data
                }
                this.loading = false
            }catch (error){

            }
        },
        async generatePayslipPDF(item, index) {
            try {
                if (this.canViewPayslip(item)) {
                    this.loading_pdf[index].value = true
                    const response = await payrollApi.getMyPayslipUrl(item.cutOffId)
                    if (response && response.status == 200) {
                        var file = {
                            name: response.data.fileName,
                            type: 'Pdf',
                            url: response.data.url,
                            downloadUrl: awsS3Helper.getEmployeeDocumentUrl(this.$store.state.userId, response.data.fileName, AWSS3DocumentType.Paylips)
                        }
                        this.$refs.refPdfPreviewComponet.setParams(file)
                        this.loading_pdf[index].value = false
                        this.dialogPreview = true
                    }
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
                this.loading_pdf[index].value = false
            }
        },
        async getCuttOffByUser() {
            try {
                this.loading = true
                const response = await payrollApi.getMyPayslipMain()              

                if (response && response.status == 200) {
                    this.cutoff_periods = response.data.summaryItems
                    this.cutoff_periods.forEach(item => {
                        this.loading_pdf.push({
                            index: item.index,
                            value: false
                        })
                    })
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }, 
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'My Payslip'
        })

        this.getCuttOffByUser()
        this.getAnnualizationByUser()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        cutoff_periods_filtered() {
            var temp = this.cutoff_periods.filter(item => {
                return (item.fiscalYear==this.selectedFiscalYear && !item.cutOffPeriodDesc.includes('Upcoming'))
            })
            if (this.search) {
                temp = temp.filter(item => {
                    return item.cutOffStart.includes(this.search)
                })
            }
            return temp //.reverse()
        },
        annualizationAdjustmentProcessed() {
            if (this.annualization)
                return this.annualization.status==commonfn.getStatusCode('Adjustments Processed') 
        },
        fiscalPeriodId() {
             if (this.annualization)
                return this.annualization.fiscalPeriodId
        },
        myUserId() {
            return this.$store.state.userId
        },
        fiscal_years() {
            if (this.$store.state.fiscalPeriods) {
                return this.$store.state.fiscalPeriods
            }
            return [{fiscalYear: new Date().getFullYear()}]
        }
    }
}
</script>